import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_ds_get_licenseplates_by_warehouses_locationsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseNames?: string[], locationContainerNames?: string[], fullTextSearch?: string, warehouseId?: number, locationId?: number, licensePlateLookupCodes?: string[], licensePlateId?: number, typeId?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, TypeId?: number, WarehouseId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseNames?: string[], locationContainerNames?: string[], fullTextSearch?: string, warehouseId?: number, locationId?: number, licensePlateLookupCodes?: string[], licensePlateId?: number, typeId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, TypeId?: number, WarehouseId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseNames?: string[], locationContainerNames?: string[], fullTextSearch?: string, warehouseId?: number, locationId?: number, licensePlateLookupCodes?: string[], licensePlateId?: number, typeId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, TypeId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseNames?: string[], locationContainerNames?: string[], fullTextSearch?: string, warehouseId?: number, locationId?: number, licensePlateLookupCodes?: string[], licensePlateId?: number, typeId?: number    }) {
      return false;
    }
}
